"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5.41 20 17 8.41V15h2V5H9v2h6.59L4 18.59z"
}), 'CallMadeTwoTone');